module.exports = __webpack_public_path__ + "static/media/Ecommerce5.ca05aa36.png";